import { render, staticRenderFns } from "./issued-reserved.vue?vue&type=template&id=0b7512c4"
import script from "./issued-reserved.vue?vue&type=script&lang=js"
export * from "./issued-reserved.vue?vue&type=script&lang=js"
import style0 from "./issued-reserved.vue?vue&type=style&index=0&id=0b7512c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports